<!-- 制药行业解决方案 -->
<template>
  <Layout>
    <!-- banner -->
    <div>
      <div class="slider-area slider-style-2 variation-3 height-720 bg_image bg_image_fixed" :style="{
        'background-image': `url(${require(`@/assets/images/IndustrySolution/banner/industry-banner-06.png`)})`,
      }">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="inner text-center">
                <h2 class="title" data-aos="fade-up" data-aos-delay="100">
                  {{ $t("solution.medicine.header.title01") }}
                </h2>
                <h4 class="subtitle color-white mb--30" data-aos="fade-up" data-aos-delay="200">
                  {{ $t("solution.medicine.header.title02") }}
                </h4>
                <p class="col-12 offset-lg-3 col-lg-6 description color-white" data-aos="fade-up" data-aos-delay="300">
                  {{ $t("solution.medicine.header.description") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-section-gapBottom industry-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <div class="row row--0 align-items-center mt_dec--30 wrapper">
                <div class="col-lg-12 mt_sm--30 mb_sm--30">
                  <div class="content row align-items-center">
                    <div class="col-12 col-lg-2 col-md-2 text-center">
                      <img class="icon" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-icon1.png')
                        " alt="" />
                    </div>
                    <div class="inner col-12 col-lg-10 col-md-10">
                      <h4 class="title mb--10">
                        {{ $t("solution.medicine.header.card.title1") }}
                      </h4>
                      <p class="description">
                        {{ $t("solution.medicine.header.card.description") }}
                      </p>
                      <h5>{{ $t("solution.medicine.header.card.title2") }}</h5>
                      <p class="description mb--0">
                        {{ $t("solution.medicine.header.card.desc1") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.medicine.header.card.desc2") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.medicine.header.card.desc3") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.medicine.header.card.desc4") }}
                      </p>
                      <p class="description mb--0">
                        {{ $t("solution.medicine.header.card.desc5") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <section class="rn-section-gap">
      <SectionTitle :title="$t('solution.solutions_title')" description="SOLUTIONS" textAlign="center" />
      <div class="container">
        <medicalSolutions />
      </div>
    </section>
    <!-- 客户价值 -->
    <custom-value customState="right" pageLayout="leftThreeHover" :list="list"></custom-value>
    <!-- 方案优势 -->
    <MedicineAdvantage />
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Icon from '../../components/icon/Icon'
import Separator from '../../components/elements/separator/Separator'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import ClassicCases from './components/ClassicCases.vue'
import medicalSolutions from './components/MedicineAdvantages/medicalSolutions'
import MedicineAdvantage from './components/MedicineAdvantage.vue'
import CustomValue from "./components/CustomValue.vue";

export default {
  name: 'Medicine',
  components: {
    Icon, Layout, Separator, SectionTitle, ClassicCases, medicalSolutions, MedicineAdvantage, CustomValue
  },
  data() {
    return {
      //产品案例
      ClassicCasesData: [
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/medical_icon01.png'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/medical_icon02.png'),
        },
        {
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/medical_icon03.png'),
        },
      ],
      // 客户价值
      list: [
        { title: this.$t('solution.medicine.values.tab.title1'), desc: this.$t('solution.medicine.values.tab.desc01') },
        { title: this.$t('solution.medicine.values.tab.title2'), desc: this.$t('solution.medicine.values.tab.desc02') },
        { title: this.$t('solution.medicine.values.tab.title3'), desc: this.$t('solution.medicine.values.tab.desc03') },
      ],
    }
  }
}
</script>